import { Text, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesFundItemResponse } from '@genial/services/dist/models';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { MovementItem } from '../MovementItem';

interface MovementationDetailsProps {
  data: ResponsesFundItemResponse[];
}

export const ItemSeparatorComponent = () => <Box bg={'neutral.lightest'} h={0.8} />;

export const MovementationDetails: React.FC<MovementationDetailsProps> = ({ data }) => {
  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Box
        alignItems={'center'}
        py={Spacing['inline.nano']}
        bg={'background'}
        borderRadius={BoxRadius.sm}>
        <Text color={'neutral.dark'} fontSize={Typography['fontsize.lg']} variant="semibold">
          Movimentação
        </Text>
      </Box>
      <FlatList
        data={data}
        showsVerticalScrollIndicator={false}
        ItemSeparatorComponent={ItemSeparatorComponent}
        keyExtractor={(item, index) => `${item.fundCnpj}-${index}`}
        renderItem={({ item }) => {
          return <MovementItem item={item} />;
        }}
      />
    </VStack>
  );
};
